import { useState } from 'react';
import { useThemeColors } from '@/shared/theme/useThemeColors';
import { semantic, typography } from '@/shared/theme/tokens';

export function PrimaryButton({ children, onClick, disabled, icon, variant = 'primary', size = 'md', type = 'button', ...rest }) {
  const [hov, setHov] = useState(false);
  const c = useThemeColors();

  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    border: 'none',
    borderRadius: '9px',
    fontFamily: typography.fontFamily.body,
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    transition: 'box-shadow 0.15s, transform 0.1s',
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
  };

  const sizes = {
    sm: { padding: '7px 14px', fontSize: '12px' },
    md: { padding: '9px 18px', fontSize: '13px' },
    lg: { padding: '11px 22px', fontSize: '14px' },
  };

  const variants = {
    primary: {
      background: semantic.btnPrimaryGrad,
      color: '#ffffff',
      boxShadow: hov && !disabled
        ? '0 4px 14px rgba(32,36,117,0.35)'
        : '0 2px 6px rgba(32,36,117,0.22)',
    },
    secondary: {
      background: c.bg,
      color: c.textActive,
      border: `1.5px solid ${c.borderInput}`,
      boxShadow: hov && !disabled ? `0 2px 8px ${c.border}` : 'none',
    },
    danger: {
      background: hov && !disabled ? semantic.errorContainer : c.bg,
      color: semantic.error,
      border: `1.5px solid ${semantic.errorBorder}`,
      boxShadow: 'none',
    },
    ghost: {
      background: hov && !disabled ? c.bgHover : 'transparent',
      color: c.textLabel,
      border: '1px solid transparent',
      boxShadow: 'none',
    },
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      {...rest}
      style={{ ...base, ...sizes[size], ...variants[variant] }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
    >
      {icon && (
        <span className="material-symbols-outlined" style={{ fontSize: size === 'sm' ? 15 : 17 }}>
          {icon}
        </span>
      )}
      {children}
    </button>
  );
}
